function HeroSection({ highlights }) {
  return (
    <section className="grid items-center gap-10 pb-12 pt-6 md:grid-cols-2 md:pb-16 md:pt-10">
      <div className="animate-fade-up space-y-6">
        <p className="inline-flex rounded-full bg-white px-4 py-2 text-xs font-semibold uppercase tracking-[0.24em] text-brand-primary shadow-sm">
          Clean Beauty, Personal Care
        </p>
        <h1 className="text-5xl leading-[0.95] text-brand-text sm:text-6xl">
          Feminine, polished results that still feel like you.
        </h1>
        <p className="max-w-xl text-base leading-8 text-brand-text/80 sm:text-lg">
          From fresh brows to soft color and styling, we focus on details that elevate your look without
          overdoing it. Simple process. Relaxed atmosphere. Beautiful finish.
        </p>
        <div className="flex flex-wrap gap-4 pt-2">
          <a
            href="/contact"
            className="rounded-full bg-brand-primary px-6 py-3 text-sm font-semibold text-white shadow-bloom transition hover:bg-brand-deep"
          >
            Book Appointment
          </a>
          <a
            href="/services"
            className="rounded-full border border-brand-primary/35 bg-white px-6 py-3 text-sm font-semibold text-brand-deep transition hover:bg-brand-mist"
          >
            Explore Services
          </a>
        </div>
      </div>

      <div className="animate-fade-up rounded-[2rem] border border-brand-petal/80 bg-white p-7 shadow-bloom md:ml-auto md:max-w-md">
        <div className="bg-dot-soft rounded-[1.3rem] border border-brand-petal/70 bg-brand-bg p-7">
          <p className="text-xs uppercase tracking-[0.25em] text-brand-primary">Why clients return</p>
          <ul className="mt-5 space-y-4 text-sm text-brand-text/90 sm:text-base">
            {highlights.map((item) => (
              <li key={item} className="flex items-start gap-3">
                <span className="mt-1 inline-block h-2.5 w-2.5 rounded-full bg-brand-primary" />
                <span>{item}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}

export default HeroSection;